/* global axios */
import ApiClient from './ApiClient';

class ContactFieldDefinitionsAPI extends ApiClient {
  constructor() {
    super('contact_field_definitions', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  reorder(fieldIds) {
    return axios.post(`${this.url}/reorder`, { fields: fieldIds });
  }
}

export default new ContactFieldDefinitionsAPI();
